import Dymo from 'dymojs'
import xmlescape from 'xml-escape'
import { accessPointSticker, boxSticker, cpeSticker, textLabel, wifiSticker } from './dymo-templates'

const dymoPrinter = new Dymo()

interface Router {
  id: string
  serialNumber: string
  model: string
  pppoeUsername: string
  pppoePassword: string
  wifiSSID: string
  wifiPassword: string
  status: string
  configVersion: string
}

export enum BoxStickerType {
  Router = 'Router',
  AccessPoint = 'AccessPoint',
  Blank = '',
}

export async function printWifiSticker(router: Router) {
  await dymoPrinter.print('DYMO LabelWriter 400 Turbo', wifiSticker(router.pppoePassword, router.wifiSSID, router.wifiPassword))
}

export async function printBoxSticker(router: Router, type: BoxStickerType = BoxStickerType.Blank) {
  const text = `${router.wifiSSID}${type !== BoxStickerType.Blank ? `\n(${type})` : ''}`
  await dymoPrinter.print('DYMO LabelWriter 400 Turbo', boxSticker(text))
}

export async function printAccessPointSticker(router: Router) {
  await dymoPrinter.print('DYMO LabelWriter 400 Turbo', accessPointSticker(router.wifiSSID, router.wifiPassword))
}

export async function renderPreview(router: Router) {
  return await dymoPrinter.renderLabel(wifiSticker(router.pppoePassword, router.wifiSSID, router.wifiPassword))
}

export async function printTextLabelArray(array: string[]) {
  const labelTemplate = textLabel()

  let labelSetXml = '<?xml version="1.0" encoding="utf-8"?>\n<LabelSet>\n'

  array.forEach((text) => {
    labelSetXml += '<LabelRecord>'
    labelSetXml += `<ObjectData Name="TextLabel">${xmlescape(text)}</ObjectData>`
    labelSetXml += '</LabelRecord>'
  })
  labelSetXml += '</LabelSet>'

  await dymoPrinter.print('DYMO LabelWriter 400 Turbo', labelTemplate, labelSetXml)
}

export async function printCpeStickerArray(labels: Array<[string, string, string]>) {
  const labelTemplate = cpeSticker()

  let labelSetXml = '<?xml version="1.0" encoding="utf-8"?>\n<LabelSet>\n'

  labels.forEach(([row1, row2, row3]) => {
    labelSetXml += '<LabelRecord>'
    labelSetXml += `<ObjectData Name="ROW1">${xmlescape(row1)}</ObjectData>`
    labelSetXml += `<ObjectData Name="ROW2">${xmlescape(row2)}</ObjectData>`
    labelSetXml += `<ObjectData Name="ROW3">${xmlescape(row3)}</ObjectData>`
    labelSetXml += '</LabelRecord>'
  })
  labelSetXml += '</LabelSet>'

  await dymoPrinter.print('DYMO LabelWriter 400 Turbo', labelTemplate, labelSetXml)
}